import type { GetStaticProps } from "next"

import { getArticlesByCategory } from "~/api/prismic/articles"
import { getCategory } from "~/api/prismic/categories"
import type { CategoryPageProps } from "~/screens/CategoryPage"
import { CategoryPage } from "~/screens/CategoryPage"
import { withLoadingFallback } from "~/utils/hocs/withLoadingFallback"
import { enhanceStaticProps } from "~/utils/next/enhanceStaticProps"
import { getPreviewRef } from "~/utils/prismic/previewData"

export { getStaticPaths } from "~/utils/next/defaultStaticPaths"

type CategoryPathParams = { uid: string }

export const getStaticProps: GetStaticProps<
  CategoryPageProps,
  CategoryPathParams
> = enhanceStaticProps<CategoryPageProps, CategoryPathParams>(
  async ({ params, previewData }) => {
    const uid = params && params.uid

    if (!uid) {
      return { notFound: true }
    }

    const category = await getCategory({
      uid,
      ref: getPreviewRef(previewData),
    })

    if (!category) {
      return { notFound: true }
    }

    const articlesRes = await getArticlesByCategory({
      categoryId: category.id,
      ref: getPreviewRef(previewData),
    })

    return {
      props: {
        uid,
        category,
        articles: articlesRes.results.map((article) => {
          article.data.body = []

          return article
        }),
        totalArticles: articlesRes.total_results_size,
      },
    }
  },
)

export default withLoadingFallback(CategoryPage)
